import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ApiService } from '@services';

/**
 * registrars service.
 *
 * @author Ruslan Kolesov
 * @class RegistrarsServiceClass
 * @category Services
 */
var RegistrarsServiceClass = /*#__PURE__*/function () {
  function RegistrarsServiceClass() {
    _classCallCheck(this, RegistrarsServiceClass);
  }

  _createClass(RegistrarsServiceClass, [{
    key: "apiRegistrarsGet",
    value:
    /**
     * Registrars get api function.
     *
     * @author Ruslan Kolesov
     * @return {Promise<ApiError | AxiosResponse<RegistrarsResponseType>>} admin console users.
     */
    function () {
      var _apiRegistrarsGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", ApiService.apiGet('/registrars', _objectSpread({
                  prefixURL: '/registrar'
                }, params)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function apiRegistrarsGet(_x) {
        return _apiRegistrarsGet.apply(this, arguments);
      }

      return apiRegistrarsGet;
    }()
    /**
     * Admin console registrars filter post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<RegistrarsResponseType>>} admin console registrars list promise.
     */

  }, {
    key: "apiSearchRegistrarPost",
    value: function () {
      var _apiSearchRegistrarPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", ApiService.apiPost('/search', _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({
                  prefixURL: '/registrar'
                }, params)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function apiSearchRegistrarPost(_x2) {
        return _apiSearchRegistrarPost.apply(this, arguments);
      }

      return apiSearchRegistrarPost;
    }()
    /**
     * Admin console delete post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>>} response.
     */

  }, {
    key: "apiDeleteUsersPost",
    value: function () {
      var _apiDeleteUsersPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", ApiService.apiPost("/delete/".concat(params.id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function apiDeleteUsersPost(_x3) {
        return _apiDeleteUsersPost.apply(this, arguments);
      }

      return apiDeleteUsersPost;
    }()
    /**
     * Registrar create post api function.
     *
     * @author Ihar Kazlouski
     * @param {string} id user id.
     * @param {AxiosRequestConfig & { body: RegistrarCreatePayload }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<string>>} registrar response promise.
     */

  }, {
    key: "apiAdminRegistrarCreatePost",
    value: function () {
      var _apiAdminRegistrarCreatePost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id, params) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", ApiService.apiPost("/registrar/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function apiAdminRegistrarCreatePost(_x4, _x5) {
        return _apiAdminRegistrarCreatePost.apply(this, arguments);
      }

      return apiAdminRegistrarCreatePost;
    }()
    /**
     * Registrar update put api function.
     *
     * @author Ihar Kazlouski
     * @param {string} id user id.
     * @param {AxiosRequestConfig & { body: RegistrarUpdatePayload }} params axios params.
     * @return {Promise<ApiError | AxiosResponse<string>>} registrar update response promise.
     */

  }, {
    key: "apiAdminRegistrarUpdatePut",
    value: function () {
      var _apiAdminRegistrarUpdatePut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", ApiService.apiPut("/registrar/".concat(id), _objectSpread({}, params === null || params === void 0 ? void 0 : params.body), _objectSpread({}, params)));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function apiAdminRegistrarUpdatePut(_x6, _x7) {
        return _apiAdminRegistrarUpdatePut.apply(this, arguments);
      }

      return apiAdminRegistrarUpdatePut;
    }()
    /**
     * Block user put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiBlockRegistrarUserPut",
    value: function () {
      var _apiBlockRegistrarUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id, params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", ApiService.apiPut("/block/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function apiBlockRegistrarUserPut(_x8, _x9) {
        return _apiBlockRegistrarUserPut.apply(this, arguments);
      }

      return apiBlockRegistrarUserPut;
    }()
    /**
     * Unblock user put api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>} promise.
     */

  }, {
    key: "apiUnBlockRegistrarUserPut",
    value: function () {
      var _apiUnBlockRegistrarUserPut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(id, params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", ApiService.apiPut("/unblock/".concat(id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/admin'
                }, params)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function apiUnBlockRegistrarUserPut(_x10, _x11) {
        return _apiUnBlockRegistrarUserPut.apply(this, arguments);
      }

      return apiUnBlockRegistrarUserPut;
    }()
    /**
     * Admin console refresh pin post api function.
     *
     * @author Ihar Kazlouski
     * @return {Promise<ApiError | AxiosResponse<string>>} response.
     */

  }, {
    key: "apiRefreshPinPost",
    value: function () {
      var _apiRefreshPinPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(params) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt("return", ApiService.apiPost("/refresh-pin/".concat(params.id), params === null || params === void 0 ? void 0 : params.body, _objectSpread({
                  prefixURL: '/auth'
                }, params)));

              case 1:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function apiRefreshPinPost(_x12) {
        return _apiRefreshPinPost.apply(this, arguments);
      }

      return apiRefreshPinPost;
    }()
  }]);

  return RegistrarsServiceClass;
}();

var RegistrarsService = new RegistrarsServiceClass();
export { RegistrarsService };